import {
  CollectionState,
  ItemId,
} from '@packages/systems/core/records/CollectionStateType';
import type {ItemRecordType} from '@packages/systems/core/records/ItemRecord';
import CollectionRecord from '@packages/systems/dynamo/records/CollectionRecord';
import Field from '@packages/systems/dynamo/records/Field';
import {List, Map} from 'immutable';

const collectionStateMock = CollectionState({
  collections: Map({
    '5b1911b6bbf932c923a8aacb': CollectionRecord({
      _id: '5b1911b6bbf932c923a8aacb',
      slug: 'category',
      name: 'Categories',
      createdOn: new Date('2018-06-07T11:06:30.320Z'),
      lastUpdated: new Date('2018-06-07T11:06:30.348Z'),
      pluralName: 'Categories',
      singularName: 'Category',
      plugin: 'cms',
      fields: List([
        Field({
          id: '04ffa5ac7e9fd4e31a9465203e667ce4',
          editable: true,
          name: 'Name',
          required: true,
          slug: 'name',
          type: 'PlainText',
          helpText: '',
        }),
        Field({
          id: '26441adec8bf6727cd5a835a1b009648',
          editable: true,
          name: 'Slug',
          required: true,
          slug: 'slug',
          type: 'PlainText',
          helpText: '',
        }),
        Field({
          id: '4958af6b6c0603fd3ec0fc5964fdda77',
          editable: true,
          name: 'Archived',
          required: true,
          slug: '_archived',
          type: 'Bool',
          helpText: '',
        }),
        Field({
          id: 'daae9d49ff72f688f0634b8dbf744dfe',
          editable: true,
          name: 'Draft',
          required: true,
          slug: '_draft',
          type: 'Bool',
          helpText: '',
        }),
        Field({
          id: '48c2c9c5c6ef83f778de201209373606',
          editable: false,
          name: 'Created On',
          required: false,
          slug: 'created-on',
          type: 'Date',
          helpText: '',
        }),
        Field({
          id: 'bf892a733c36f49bc302663c74afeaed',
          editable: false,
          name: 'Updated On',
          required: false,
          slug: 'updated-on',
          type: 'Date',
          helpText: '',
        }),
        Field({
          id: 'a5f13b5f1298f5a7475dfc7a2d6a6d37',
          editable: false,
          name: 'Published On',
          required: false,
          slug: 'published-on',
          type: 'Date',
          helpText: '',
        }),
        Field({
          id: '6cb99608229d9ae57423a8e4c6a2fb97',
          editable: false,
          name: 'Created By',
          required: false,
          slug: 'created-by',
          type: 'User',
          helpText: '',
        }),
        Field({
          id: '3ce9c8f61f2b35c833d81d6d6bd2cc19',
          editable: false,
          name: 'Updated By',
          required: false,
          slug: 'updated-by',
          type: 'User',
          helpText: '',
        }),
        Field({
          id: 'db8369d8167921a1bd85ae2bf614133d',
          editable: false,
          name: 'Published By',
          required: false,
          slug: 'published-by',
          type: 'User',
          helpText: '',
        }),
      ]),
      itemCount: 0,
    }),
  }),
  items: Map<ItemId, ItemRecordType>({
    '601877b502d159653955e559': {
      _archived: false,
      _cid: '5b1911b6bbf932c923a8aacb',
      _draft: false,
      _id: '601877b502d159653955e559',
      'created-by': 'Person_593a8d5ab0a9e69a505a7795',
      'created-on': '2018-10-15T15:32:25.050Z',
      name: 'Dolorem Ut Consequatur',
      slug: 'dolorem-ut-consequatur',
      'published-by': 'Person_593a8d5ab0a9e69a505a7795',
      'updated-by': 'Person_593a8d5ab0a9e69a505a7795',
      'updated-on': '2018-10-15T15:32:25.050Z',
      'published-on': '2018-10-15T16:24:00.261Z',
    },
    '601877b502d159653955e55a': {
      _archived: false,
      _cid: '5b1911b6bbf932c923a8aacb',
      _draft: false,
      _id: '601877b502d159653955e55a',
      'created-by': 'Person_593a8d5ab0a9e69a505a7795',
      'created-on': '2018-10-15T15:32:25.050Z',
      name: 'Aperiam Optio',
      slug: 'aperiam-optio',
      'published-by': 'Person_593a8d5ab0a9e69a505a7795',
      'updated-by': 'Person_593a8d5ab0a9e69a505a7795',
      'updated-on': '2018-10-15T15:32:25.050Z',
      'published-on': '2018-10-15T16:24:00.261Z',
    },
    '601877b502d159653955e55b': {
      _archived: false,
      _cid: '5b1911b6bbf932c923a8aacb',
      _draft: false,
      _id: '601877b502d159653955e55b',
      'created-by': 'Person_593a8d5ab0a9e69a505a7795',
      'created-on': '2018-10-15T15:32:25.050Z',
      name: 'Sed',
      slug: 'sed',
      'published-by': 'Person_593a8d5ab0a9e69a505a7795',
      'updated-by': 'Person_593a8d5ab0a9e69a505a7795',
      'updated-on': '2018-10-15T15:32:25.050Z',
      'published-on': '2018-10-15T16:24:00.261Z',
    },
  }),
});

export default collectionStateMock;
